enum TeethImageType {
  'PLAIN' = 'PLAIN',
  'DISABLED' = 'DISABLED',
  'EXTRACTED' = 'EXTRACTED',
  'CLASSII_HOOK' = 'CLASSII_HOOK',
  'CLASSIII_HOOK' = 'CLASSIII_HOOK',
}

export { TeethImageType }
